import { IconProp, SizeProp } from "@fortawesome/fontawesome-svg-core"

export type CustomActionIconProps = {
  label: string
  labelKey?: string
  icon: IconProp
  color?: "primary" | "secondary" | "error" | "info" | "success" | "warning"
}

export interface ActionIconButtonProps {
  iconSize?: SizeProp
  type: ActionIconButtonTypeEnum
  custom?: CustomActionIconProps
  handleOnClick: () => void
}

export enum ActionIconButtonTypeEnum {
  Custom = "Custom",
  Book = "Book",
  Edit = "Edit",
  Approve = "Approve",
  View = "View",
  SendNotification = "SendNotification"
}
